// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hos-addendum-container {
  padding: 0;
  position: relative;
}

.hos-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.25s ease-out;
}

.hos-loading-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  width: 90%;
}

button.reload-btn {
  width: 49px;
  height: 39px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(106, 206, 106, 0.1) url('reload.4f948bc26ec6cc5d.svg') no-repeat center center !important;
  border-radius: 5px !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
button.reload-btn:hover:not(:disabled) {
  background-color: rgba(106, 206, 106, 0.2) !important;
}
button.reload-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
button.reload-btn.is-loading {
  animation: reload-spin 0.9s linear infinite;
}

@keyframes reload-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge-new {
  background-color: #e0f2fe;
  color: #0284c7;
  border: 1px solid #bae6fd;
}
.badge-subsequent {
  background-color: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}
.badge-signed {
  background-color: #dcfce7;
  color: #15803d;
  border: 1px solid #86efac;
}
.badge-expired {
  background-color: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.badge-superseded {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}
.badge-resends {
  background-color: #f1f5f9;
  color: #475569;
  border: 1px solid #cbd5e1;
  text-transform: none;
  font-size: 11px;
  font-weight: 600;
}

.tabs-nav {
  border-bottom: 2px solid #e2e8f0;
}
.tabs-nav .tab-btn {
  background: transparent;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s ease;
}
.tabs-nav .tab-btn:hover {
  color: #0284c7;
}
.tabs-nav .tab-btn.active {
  color: #0284c7;
  border-bottom-color: #0284c7;
}
.tabs-nav .tab-btn .history-count {
  font-size: 12px;
  color: #94a3b8;
}

.clock-banner {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}
.clock-banner .clock-title {
  font-weight: 700;
  font-size: 13px;
  color: #166534;
}
.clock-banner .clock-badge {
  background: #dcfce7;
  color: #15803d;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}
.clock-banner .clock-desc {
  font-size: 12px;
  color: #15803d;
}
.clock-banner .clock-meta {
  font-size: 12px;
  color: #166534;
}
.clock-banner .clock-meta em {
  font-size: 11px;
}

.failed-banner {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #7f1d1d;
}
.failed-banner .failed-title {
  font-weight: 700;
  font-size: 13px;
  color: #991b1b;
}

.signed-banner {
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 8px;
}
.signed-banner .signed-title {
  font-weight: 700;
  font-size: 13px;
  color: #166534;
}

.status-pill {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}
.status-pill.status-draft {
  background: #f1f5f9;
  color: #64748b;
}
.status-pill.status-pending {
  background: #fef3c7;
  color: #b45309;
}
.status-pill.status-signed {
  background: #dcfce7;
  color: #15803d;
}
.status-pill.status-failed {
  background: #fee2e2;
  color: #b91c1c;
}
.status-pill.status-superseded {
  background: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}

.upload-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s;
}
.upload-dropzone:hover {
  border-color: #0284c7;
  background: #f0f9ff;
}

.dynamic-prep-info {
  background: #f1f5f9;
  border-radius: 6px;
}
.dynamic-prep-info .dynamic-list {
  margin: 0;
}
.dynamic-prep-info .dynamic-list li {
  line-height: 1.6;
  color: #475569;
}

.alert-warning {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
}

.history-card {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.history-card .status-pill {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}
.history-card .status-pill.status-draft {
  background: #f1f5f9;
  color: #64748b;
}
.history-card .status-pill.status-pending {
  background: #fef3c7;
  color: #b45309;
}
.history-card .status-pill.status-signed {
  background: #dcfce7;
  color: #15803d;
}
.history-card .status-pill.status-expired {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.history-card .status-pill.status-superseded {
  background: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}
.history-card .history-tag {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 3px;
  background: #e2e8f0;
  color: #475569;
}

.note-box {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}

/* The signing clock start date dialog opens from within the upload sidebar. It must appear in front of the sidebar (z-index 1100). */
::ng-deep .p-dialog-mask {
  z-index: 1200 !important;
}

/* Its date field: the typed date and the calendar button sit apart, the text is padded like every other
   field on this screen, and both keep their own rounded corners. */
::ng-deep .hos-upload-date.p-calendar {
  gap: 8px;
}
::ng-deep .hos-upload-date.p-calendar .p-inputtext {
  padding: 12px 16px !important;
  border: 1px solid #D1D5DB;
  border-radius: 6px !important;
  font-size: 14px;
}
::ng-deep .hos-upload-date.p-calendar .p-datepicker-trigger {
  border-radius: 6px !important;
}

/* The calendar is appended to the page so the whole month shows, which put it behind the dialog's mask
   above (PrimeNG gave it 1050): it opened, but nobody could see it. */
::ng-deep .hos-upload-date-panel {
  z-index: 1210 !important;
}

/* Ensure inputs, labels and calendar in HOS addendum match E-Sign exactly */
::ng-deep .hos-addendum-sidebar .p-sidebar-header {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
::ng-deep .hos-addendum-sidebar .p-sidebar-content {
  padding-top: 0.5rem !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form {
  padding: 25px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form label, ::ng-deep .hos-addendum-sidebar .sidebar-form .p-checkbox-label {
  font-family: "Montserrat", sans-serif !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 30px !important;
  color: #1F2937 !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext {
  height: 54px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 6px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left {
  position: relative;
  display: flex;
  align-items: center;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon {
  position: absolute;
  left: 18px;
  top: 17px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon img {
  width: 18px;
  height: 18px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon em {
  font-size: 18px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .p-inputtext {
  padding-left: 48px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.disable-calendar {
  width: 100%;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.disable-calendar .p-inputtext {
  height: 54px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 6px !important;
  padding: 12px 16px 12px 48px !important;
  font-size: 14px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputmask {
  width: 100%;
}
::ng-deep .hos-addendum-sidebar .sidebar-form textarea.p-inputtext {
  height: auto !important;
  min-height: 90px !important;
  padding: 12px 16px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext[readonly],
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext:disabled,
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.p-disabled .p-inputtext,
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputmask.p-disabled .p-inputtext {
  background-color: #f8fafc !important;
  color: #475569 !important;
  border-color: #e2e8f0 !important;
  cursor: default !important;
}

.p-button.btn-audit-log {
  background: #f97316;
  border-color: #f97316;
  color: #ffffff;
}
.p-button.btn-audit-log:enabled:hover {
  background: #ea580c;
  border-color: #ea580c;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/app/e-soc/hos-addendum/hos-addendum.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AACF;;AAEA;EACE,qCAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,mFAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0GAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AACF;AACE;EACE,qDAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,2CAAA;AADJ;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAHF;AAKE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AALJ;AAQE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AANJ;AASE;EACE,yBAAA;EACA,cAAA;EACA,0BAAA;AAPJ;AAUE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AARJ;;AAYA;EACE,gCAAA;AATF;AAWE;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;AATJ;AAWI;EACE,cAAA;AATN;AAYI;EACE,cAAA;EACA,4BAAA;AAVN;AAaI;EACE,eAAA;EACA,cAAA;AAXN;;AAgBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAbF;AAeE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,cAAA;AAfJ;AAqBE;EACE,eAAA;EACA,cAAA;AAnBJ;AAqBI;EACE,eAAA;AAnBN;;AAwBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AArBF;AAuBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AArBJ;;AAyBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAtBF;AAwBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAtBJ;;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAvBF;AAyBE;EACE,mBAAA;EACA,cAAA;AAvBJ;AAyBE;EACE,mBAAA;EACA,cAAA;AAvBJ;AAyBE;EACE,mBAAA;EACA,cAAA;AAvBJ;AAyBE;EACE,mBAAA;EACA,cAAA;AAvBJ;AAyBE;EACE,mBAAA;EACA,cAAA;EACA,0BAAA;AAvBJ;;AA2BA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAxBF;AA0BE;EACE,qBAAA;EACA,mBAAA;AAxBJ;;AA4BA;EACE,mBAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,SAAA;AAzBJ;AA0BI;EACE,gBAAA;EACA,cAAA;AAxBN;;AA6BA;EACE,yBAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,yCAAA;AA1BF;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,mBAAA;EACA,cAAA;AA1BN;AA4BI;EACE,mBAAA;EACA,cAAA;AA1BN;AA4BI;EACE,mBAAA;EACA,cAAA;AA1BN;AA4BI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA1BN;AA4BI;EACE,mBAAA;EACA,cAAA;EACA,0BAAA;AA1BN;AA8BE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA5BJ;;AAgCA;EACE,mBAAA;EACA,yBAAA;AA7BF;;AAgCA,qIAAA;AACA;EACE,wBAAA;AA7BF;;AAgCA;mEAAA;AAEA;EACE,QAAA;AA7BF;AA+BE;EACE,6BAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,6BAAA;AA9BJ;;AAkCA;sEAAA;AAEA;EACE,wBAAA;AA/BF;;AAkCA,4EAAA;AAEE;EACE,2BAAA;EACA,4BAAA;AAhCJ;AAmCE;EACE,8BAAA;AAjCJ;AAoCE;EACE,aAAA;AAlCJ;AAoCI;EACE,gDAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AAlCN;AAqCI;EACE,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;AAnCN;AAsCI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AApCN;AAsCM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCR;AAsCQ;EACE,WAAA;EACA,YAAA;AApCV;AAuCQ;EACE,eAAA;AArCV;AAyCM;EACE,6BAAA;AAvCR;AA2CI;EACE,WAAA;AAzCN;AA0CM;EACE,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,0BAAA;AAxCR;AA4CI;EACE,WAAA;AA1CN;AA6CI;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;AA3CN;AA8CI;;;;EAIE,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;AA5CN;;AAkDA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA/CF;AAiDE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA/CJ","sourcesContent":[".hos-addendum-container {\n  padding: 0;\n  position: relative;\n}\n\n.hos-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  z-index: 11000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.25s ease-out;\n}\n\n.hos-loading-card {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 380px;\n  width: 90%;\n}\n\nbutton.reload-btn {\n  width: 49px;\n  height: 39px !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(106, 206, 106, 0.1) url(\"../../../assets/images/reload.svg\") no-repeat center center !important;\n  border-radius: 5px !important;\n  border: none !important;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n\n  &:hover:not(:disabled) {\n    background-color: rgba(106, 206, 106, 0.2) !important;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.is-loading {\n    animation: reload-spin 0.9s linear infinite;\n  }\n}\n\n@keyframes reload-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n\n  &-new {\n    background-color: #e0f2fe;\n    color: #0284c7;\n    border: 1px solid #bae6fd;\n  }\n\n  &-subsequent {\n    background-color: #fef3c7;\n    color: #d97706;\n    border: 1px solid #fde68a;\n  }\n\n  &-signed {\n    background-color: #dcfce7;\n    color: #15803d;\n    border: 1px solid #86efac;\n  }\n\n  &-expired {\n    background-color: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n  }\n\n  &-superseded {\n    background-color: #fef2f2;\n    color: #991b1b;\n    border: 1px dashed #fca5a5;\n  }\n\n  &-resends {\n    background-color: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n    text-transform: none;\n    font-size: 11px;\n    font-weight: 600;\n  }\n}\n\n.tabs-nav {\n  border-bottom: 2px solid #e2e8f0;\n\n  .tab-btn {\n    background: transparent;\n    border: none;\n    padding: 10px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: all 0.2s ease;\n\n    &:hover {\n      color: #0284c7;\n    }\n\n    &.active {\n      color: #0284c7;\n      border-bottom-color: #0284c7;\n    }\n\n    .history-count {\n      font-size: 12px;\n      color: #94a3b8;\n    }\n  }\n}\n\n.clock-banner {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n\n  .clock-title {\n    font-weight: 700;\n    font-size: 13px;\n    color: #166534;\n  }\n\n  .clock-badge {\n    background: #dcfce7;\n    color: #15803d;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 10px;\n  }\n\n  .clock-desc {\n    font-size: 12px;\n    color: #15803d;\n  }\n\n  // The deadline and last-contact line. A shade darker than the description around it: this is\n  // reference detail staff scan for rather than prose, and it must stay readable when it wraps\n  // on a narrow window.\n  .clock-meta {\n    font-size: 12px;\n    color: #166534;\n\n    em {\n      font-size: 11px;\n    }\n  }\n}\n\n.failed-banner {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  border-radius: 8px;\n  color: #7f1d1d;\n\n  .failed-title {\n    font-weight: 700;\n    font-size: 13px;\n    color: #991b1b;\n  }\n}\n\n.signed-banner {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  border-radius: 8px;\n\n  .signed-title {\n    font-weight: 700;\n    font-size: 13px;\n    color: #166534;\n  }\n}\n\n.status-pill {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n\n  &.status-draft {\n    background: #f1f5f9;\n    color: #64748b;\n  }\n  &.status-pending {\n    background: #fef3c7;\n    color: #b45309;\n  }\n  &.status-signed {\n    background: #dcfce7;\n    color: #15803d;\n  }\n  &.status-failed {\n    background: #fee2e2;\n    color: #b91c1c;\n  }\n  &.status-superseded {\n    background: #fef2f2;\n    color: #991b1b;\n    border: 1px dashed #fca5a5;\n  }\n}\n\n.upload-dropzone {\n  border: 2px dashed #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    border-color: #0284c7;\n    background: #f0f9ff;\n  }\n}\n\n.dynamic-prep-info {\n  background: #f1f5f9;\n  border-radius: 6px;\n\n  .dynamic-list {\n    margin: 0;\n    li {\n      line-height: 1.6;\n      color: #475569;\n    }\n  }\n}\n\n.alert-warning {\n  background-color: #fffbeb;\n  border: 1px solid #fef3c7;\n}\n\n.history-card {\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n  .status-pill {\n    font-size: 10px;\n    font-weight: 700;\n    padding: 2px 6px;\n    border-radius: 4px;\n\n    &.status-draft {\n      background: #f1f5f9;\n      color: #64748b;\n    }\n    &.status-pending {\n      background: #fef3c7;\n      color: #b45309;\n    }\n    &.status-signed {\n      background: #dcfce7;\n      color: #15803d;\n    }\n    &.status-expired {\n      background: #fee2e2;\n      color: #b91c1c;\n      border: 1px solid #fca5a5;\n    }\n    &.status-superseded {\n      background: #fef2f2;\n      color: #991b1b;\n      border: 1px dashed #fca5a5;\n    }\n  }\n\n  .history-tag {\n    font-size: 9px;\n    font-weight: 700;\n    padding: 2px 4px;\n    border-radius: 3px;\n    background: #e2e8f0;\n    color: #475569;\n  }\n}\n\n.note-box {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n}\n\n/* The signing clock start date dialog opens from within the upload sidebar. It must appear in front of the sidebar (z-index 1100). */\n::ng-deep .p-dialog-mask {\n  z-index: 1200 !important;\n}\n\n/* Its date field: the typed date and the calendar button sit apart, the text is padded like every other\n   field on this screen, and both keep their own rounded corners. */\n::ng-deep .hos-upload-date.p-calendar {\n  gap: 8px;\n\n  .p-inputtext {\n    padding: 12px 16px !important;\n    border: 1px solid #D1D5DB;\n    border-radius: 6px !important;\n    font-size: 14px;\n  }\n\n  .p-datepicker-trigger {\n    border-radius: 6px !important;\n  }\n}\n\n/* The calendar is appended to the page so the whole month shows, which put it behind the dialog's mask\n   above (PrimeNG gave it 1050): it opened, but nobody could see it. */\n::ng-deep .hos-upload-date-panel {\n  z-index: 1210 !important;\n}\n\n/* Ensure inputs, labels and calendar in HOS addendum match E-Sign exactly */\n::ng-deep .hos-addendum-sidebar {\n  .p-sidebar-header {\n    margin-bottom: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .p-sidebar-content {\n    padding-top: 0.5rem !important;\n  }\n\n  .sidebar-form {\n    padding: 25px;\n\n    label, .p-checkbox-label {\n      font-family: 'Montserrat', sans-serif !important;\n      font-weight: 600 !important;\n      font-size: 15px !important;\n      line-height: 30px !important;\n      color: #1F2937 !important;\n    }\n\n    .p-inputtext {\n      height: 54px !important;\n      border: 1px solid #D1D5DB !important;\n      border-radius: 6px !important;\n      padding: 12px 16px !important;\n      font-size: 14px !important;\n    }\n\n    .p-input-icon-left {\n      position: relative;\n      display: flex;\n      align-items: center;\n\n      .gc-input-icon {\n        position: absolute;\n        left: 18px;\n        top: 17px;\n        z-index: 9;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img {\n          width: 18px;\n          height: 18px;\n        }\n\n        em {\n          font-size: 18px;\n        }\n      }\n\n      .p-inputtext {\n        padding-left: 48px !important;\n      }\n    }\n\n    .p-calendar.disable-calendar {\n      width: 100%;\n      .p-inputtext {\n        height: 54px !important;\n        border: 1px solid #D1D5DB !important;\n        border-radius: 6px !important;\n        padding: 12px 16px 12px 48px !important;\n        font-size: 14px !important;\n      }\n    }\n\n    .p-inputmask {\n      width: 100%;\n    }\n\n    textarea.p-inputtext {\n      height: auto !important;\n      min-height: 90px !important;\n      padding: 12px 16px !important;\n    }\n\n    .p-inputtext[readonly],\n    .p-inputtext:disabled,\n    .p-calendar.p-disabled .p-inputtext,\n    .p-inputmask.p-disabled .p-inputtext {\n      background-color: #f8fafc !important;\n      color: #475569 !important;\n      border-color: #e2e8f0 !important;\n      cursor: default !important;\n    }\n  }\n}\n\n// Download Audit Log: solid orange with white text, on the signed view and in the history.\n.p-button.btn-audit-log {\n  background: #f97316;\n  border-color: #f97316;\n  color: #ffffff;\n\n  &:enabled:hover {\n    background: #ea580c;\n    border-color: #ea580c;\n    color: #ffffff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
